export default "__VITE_ASSET__32QhdUIG__"